import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { getCourseDetails, getCourseRevoke } from '@/api/index-gai'; // 习练接口
import { validateNull } from '@/util/validate';
import { skipUrl as skipUrlOpen } from '@/util/util';
import { getEnvName } from '@/util/env';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
export default {
  __name: 'CourseDialog',
  props: /*@__PURE__*/_mergeModels({
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }, {
    "visible": false,
    "visibleModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['refresh', 'change'], ["update:visible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var tagStyles = [{
      color: '#f3683a',
      backgroundColo: 'rgb(243 104 58 / 10%)'
    }, {
      color: '#f9af03',
      backgroundColo: 'rgb(249 175 3 / 10%)'
    }, {
      color: '#3a63f3',
      backgroundColo: 'rgb(58 99 243 / 10%)'
    }, {
      color: '#7787a2',
      backgroundColo: 'rgb(119 135 162 / 10%)'
    }];
    var tagLabels = ['未发布', '未开始', '进行中', '已结束'];
    var _storeToRefs = storeToRefs(useUserStore()),
      appAliasUrl = _storeToRefs.appAliasUrl,
      userInfo = _storeToRefs.userInfo,
      token = _storeToRefs.token;
    var emit = __emit;
    var props = __props;
    /**
     * @description: 列表配置
     */
    var columnsCourse = [{
      colKey: 'groupName',
      title: '群组',
      ellipsis: true
    }, {
      colKey: 'process',
      title: '学程进度',
      width: 100
    }, {
      colKey: 'startTime',
      title: '开始时间',
      ellipsis: true
    }, {
      colKey: 'endTime',
      title: '结束时间',
      ellipsis: true
    }, {
      colKey: 'btn',
      title: '操作',
      width: 580
    }];
    var visible = _useModel(__props, 'visible', false);
    var tableData = ref([]);
    var isLoading = ref(false);
    var handleClose = function handleClose() {
      visible.value = false;
    };
    /**
     * 获取习题详情
     */
    var initData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _props$item, id, courseVersion, creatorId, res, _res$data, code, data, tempList, isOwn, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!validateNull(props.item)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              isLoading.value = true;
              _props$item = props.item, id = _props$item.id, courseVersion = _props$item.courseVersion, creatorId = _props$item.creatorId;
              _context.n = 2;
              return getCourseDetails(id);
            case 2:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                tempList = data || [];
                isOwn = creatorId === userInfo.value.id;
                tableData.value = tempList.map(function (row) {
                  var disabled = row.process === 0;
                  var demoDis = disabled || courseVersion === 1;
                  var feedbackDis = disabled || !row.hasFeedback;
                  var publishDis = !disabled || courseVersion === 2 || row.source;
                  var adjustDis = disabled || !isOwn;
                  var tagStyle = tagStyles[row.process];
                  var tagLabel = tagLabels[row.process];
                  return _objectSpread(_objectSpread({}, row), {}, {
                    disabled: disabled,
                    demoDis: demoDis,
                    feedbackDis: feedbackDis,
                    publishDis: publishDis,
                    adjustDis: adjustDis,
                    tagStyle: tagStyle,
                    tagLabel: tagLabel
                  });
                });
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error(_t.massage || '获取习题详情失败');
            case 4:
              _context.p = 4;
              isLoading.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function initData() {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(function () {
      return visible.value;
    }, function (val) {
      val && initData();
    }, {
      immediate: true,
      deep: true
    });
    /**
     * @description: 学程演示
     */
    var toShowCourse = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var queryUrl;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              queryUrl = "courseId=".concat(row.courseId, "&groupId=").concat(row.groupId, "&deptId=").concat(row.deptId);
              openApp('demonstrate', queryUrl);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function toShowCourse(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    /**
     * @description: 反馈
     */
    var toFeedback = function toFeedback(row) {
      var resourceName = props.item.resourceName;
      var queryUrl = "courseId=".concat(row.courseId, "&deptId=").concat(row.deptId, "&groupId=").concat(row.groupId, "&title=").concat(resourceName, "&groupName=").concat(row.groupName);
      openApp('FeedbackStatic', queryUrl);
    };
    /**
     * @description: 作品管理
     */
    var toWorkManage = function toWorkManage(row) {
      var resourceName = props.item.resourceName;
      var queryUrl = "courseId=".concat(row.courseId, "&deptId=").concat(row.deptId, "&groupId=").concat(row.groupId, "&title=").concat(resourceName, "&groupName=").concat(row.groupName);
      openApp('preparation', queryUrl);
    };

    /**
     * @description: 撤销
     */
    var revokeClick = function revokeClick(row) {
      var DialogInstance = DialogPlugin.confirm({
        theme: 'warning',
        header: '是否撤销当前发布？',
        confirmBtn: '是',
        cancelBtn: '否',
        onConfirm: function onConfirm() {
          revokeRequest(DialogInstance, row);
        }
      });
    };
    /**
     * @description: 撤销发布
     */
    var revokeRequest = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dialog, row) {
        var res, code, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return getCourseRevoke(row.courseId, row.groupId);
            case 1:
              res = _context3.v;
              code = res.data.code;
              if (code === 0) {
                MessagePlugin.closeAll();
                MessagePlugin.success('撤销发布成功！');
                dialog.destroy();
                row.process = 0;
                emit('refresh');
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              MessagePlugin.error(_t2.massage || '获取失败');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      return function revokeRequest(_x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }();
    /**
     * @description: 发布
     */
    var clickPubilsh = function clickPubilsh(row) {
      var courseVersion = props.item.courseVersion;
      var courseId = row.courseId;
      var queryUrl = "?id%3D".concat(courseId, "%26type%3Dcourse%26courseVersion%3D").concat(courseVersion, "%26perate%3Drelease");
      var url = "".concat(appAliasUrl.value, "?prepareLesson=/releasePage").concat(queryUrl);
      skipUrlOpen(url, '_blank');
    };
    /**
     * @description: 调整
     */
    var adjustClick = function adjustClick(row) {
      var courseVersion = props.item.courseVersion;
      var courseId = row.courseId,
        groupId = row.groupId;
      var queryUrl = "?id%3D".concat(courseId, "%26type%3Dcourse%26courseVersion%3D").concat(courseVersion, "%26operate%3Dset%26groupId%3D").concat(groupId);
      var url = "".concat(appAliasUrl.value, "?prepareLesson=/releasePage").concat(queryUrl);
      skipUrlOpen(url, '_blank');
    };
    /**
     * @description: 打开应用
     */
    var openApp = function openApp(appAlias, queryUrl) {
      var env_name = getEnvName();
      var url = "//".concat(env_name || 'edu-', "course.zhixuehuijiao");
      skipUrlOpen("".concat(url, ".cn/").concat(appAlias, "?token=").concat(token.value, "&").concat(queryUrl), '_blank');
    };
    return function (_ctx, _cache) {
      var _component_t_tag = _resolveComponent("t-tag");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_table = _resolveComponent("t-table");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        class: "course-dialog",
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        header: "学程详情",
        destroyOnClose: "",
        footer: false,
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        width: "1200px",
        "on-close": handleClose
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_table, {
            class: "course-table-box",
            "row-key": "id",
            data: tableData.value,
            columns: columnsCourse,
            bordered: "",
            maxHeight: "400px"
          }, {
            process: _withCtx(function (_ref5) {
              var row = _ref5.row;
              return [_createVNode(_component_t_tag, {
                style: _normalizeStyle(row.tagStyle),
                variant: "light"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(row.tagLabel), 1)];
                }),
                _: 2
              }, 1032, ["style"])];
            }),
            btn: _withCtx(function (_ref6) {
              var row = _ref6.row;
              return [_createElementVNode("div", null, [_createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: row.demoDis,
                onClick: function onClick($event) {
                  return toShowCourse(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[1] || (_cache[1] = [_createTextVNode("演示", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: row.feedbackDis,
                onClick: function onClick($event) {
                  return toFeedback(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("反馈", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: row.disabled,
                onClick: function onClick($event) {
                  return toWorkManage(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" 作品管理 ", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: row.disabled,
                onClick: function onClick($event) {
                  return emit('change', row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("批阅", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: ""
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("查看统计", -1)]));
                }),
                _: 1
              }), _createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: row.publishDis,
                onClick: function onClick($event) {
                  return clickPubilsh(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode("发布", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: row.adjustDis,
                onClick: function onClick($event) {
                  return revokeClick(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode(" 撤销 ", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"]), _createVNode(_component_t_button, {
                variant: "text",
                theme: "primary",
                disabled: row.adjustDis,
                onClick: function onClick($event) {
                  return adjustClick(row);
                }
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode("调整 ", -1)]));
                }),
                _: 1
              }, 8, ["disabled", "onClick"])])];
            }),
            _: 1
          }, 8, ["data"])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};